import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import VueI18n from 'vue-i18n'
import messages from './localization/messages.js'

import User from './application/user.js'
import Authways from './application/authways.js'
import Axioswr from './application/axioswr.js'
import Api from '../../assistant/src/application/api'
import WSS from '../../assistant/src/application/wss'

///////////Components

  import preloader from '@/components/assets/preloader/index.vue'
  import linepreloader from '@/components/assets/linepreloader/index.vue'
  import userpic from '@/components/assets/userpic/index.vue'
  import fixedmessageicon from '@/components/assets/fixedmessageicon/index.vue'

  import Vuelidate from 'vuelidate'
  import VueObserveVisibility from 'vue-observe-visibility'
  import Message from 'vue-m-message'
  import SweetAlertIcons from 'vue-sweetalert-icons';

  import 'vue-m-message/dist/index.css'

  import f from '../../assistant/src/application/functions'
  import _ from 'lodash'; 

  import modal from '@/components/assets/modal/index.vue'
  import bgimage from '@/components/assets/bgimage.vue'

/////////////////////////////////////////

import { VTooltip, VPopover, VClosePopover } from 'v-tooltip'
import Wai from "@/application/wai";

var VueStickyKit = require('vue-stickykit')
Vue.use(VueStickyKit)

Vue.directive('tooltip', VTooltip)
Vue.directive('close-popover', VClosePopover)
Vue.component('v-popover', VPopover)

var server = "https://wellai.health:3000";
var wsserver = "wss://wellai.health:8085/";
var pyserver = "https://wellai.health:3000";
var peerhost = "wellai.health"
/*
wsserver = "wss://localhost:8085/"
server = "https://localhost:3000"   
peerhost = "localhost"*/

/////////////////////////////////////////

var VueScrollTo = require('vue-scrollto');

Vue.use(VueScrollTo, {
  container: "html",
  duration: 200,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

Vue.config.productionTip = false
Vue.prototype._ = _
Vue.prototype.$f = f

Vue.use(VueI18n)
Vue.use(Vuelidate)
Vue.use(VueObserveVisibility)
Vue.use(SweetAlertIcons);
Vue.use(Message) // will mount `Vue.prototype.$message`

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      if (!(el == event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
});

const i18n = new VueI18n({
  locale: 'en-US',
  messages : messages
})

var deviceready = function(clbk){


		if(typeof window.cordova != 'undefined')
		{
			document.addEventListener('deviceready', function(){

        window.screen.orientation.lock('portrait')
				
        navigator.splashscreen.hide();			

        if(window.device.platform === 'iOS') {
          cordova.plugins.iosrtc.registerGlobals();
        }

        if(typeof community != 'undefined')
          community.preventsleep.setPreventSleep(true);

        clbk()
        
			}, false);
		}
		else
		{
			clbk()
		}


}



var user = null,
    axios = null, 
    ws = null,
    api = null,
    wai = null,
    authways = null;

    Vue.component('preloader', preloader)
    Vue.component('linepreloader', linepreloader)
    Vue.component('userpic', userpic)
    Vue.component('fixedmessageicon', fixedmessageicon)
    Vue.component('modal', modal)
    Vue.component('bgimage', bgimage)



var globalkit = {

  file : (id, key, type) => { 
    return server + '/res/files?id=' + id + '&key=' + key + '&type=' + type
  },

  install: function(Vue){
    Object.defineProperty(Vue.prototype, 'gk', {
      get () { return globalkit }
    })
  }
};

Vue.use(globalkit)

var vm = new Vue({

  i18n,
  router,
  store,


  data : {

    servers : {
      main : server,
      py : pyserver,
    },

    systems : {
      main : "wai",
      py : 'wai'
    },

    prefix : {
      main : 'wai',
      py : 'wai'
    },
  },

  computed : {
      user : () => user,
      axios : () => axios,
      api : () => api,
      f : () => f,
      ws : () => ws,
      wai : () => wai,
      authways : () => authways,
  },

  created : function(){

    api = new Api({ vm : this })
    user = new User({ vm : this, api })

    var pps = {
      user,
      api,
      vm : this,
      f : f
    }

    authways = new Authways(pps)
    wai = new Wai(pps)

    axios = new Axioswr(pps)
    ws = new WSS(pps, wsserver)
    ws.init()

    pps.ws = ws
    user.ws = ws


    deviceready(function(){      
      
    })

    authways.init().then(() => {

      return wai.init()

    })

  },

  beforeCreate() {
		this.$store.commit('init');
	},
  
  render: h => h(App),

 
  
}).$mount('#app')

